export function errorHandler(action: () => void, onError?: (err) => any) {
  try {
    action();
  } catch (err) {
    console.error('Handled:', err);
    if (onError) {
      onError(err);
    }
  }
}
